var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { E as EntityType, a as EnemyTypeEnum } from "../enums-86f58524.js";
import { componentRegistered } from "../components/ComponentRegistry.js";
import { clone } from "../utils/clone.js";
import { StringToEnum } from "../utils/typehelpers.js";
import { getEnum } from "../constants/index.js";
import AssetLoader from "../loader/AssetLoader.js";
import toposort from "toposort";
import { s as setGlobalSingleton, g as getGlobalSingleton } from "../global-33d5eebf.js";
import { cloneDeep } from "lodash";
import { hexToRgbNumber } from "../utils/colors.js";
import { P as ParentSchema } from "../Parent-b4f1af10.js";
import { ListenEntityCreationSchema, ListenEntityCreationSystem } from "../components/core/ListenEntityCreation.js";
import "../decorators/type.js";
import "ajv";
import "bitecs";
import "../components/types.js";
import "../utils/byteArray.js";
import "../loader/ImageLoader.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
class EntityFactory {
  constructor(entityDefinitions) {
    __publicField(this, "entityDefinitionMap", /* @__PURE__ */ new Map());
    __publicField(this, "entityDefinitionStringMap", /* @__PURE__ */ new Map());
    __publicField(this, "getEntityType", (entityName) => {
      var _a;
      try {
        const entityType = StringToEnum(
          ((_a = this.entityDefinitionMap.get(entityName.toLowerCase())) == null ? void 0 : _a.type) || "",
          EntityType
        );
        if (!entityType) {
          throw new Error(`Could not find entity type for ${entityName}`);
        }
        return entityType;
      } catch (e) {
        console.error(entityName);
        console.error(e);
        throw e;
      }
    });
    __publicField(this, "findEntitiesWithComponent", (componentName) => {
      const entities = [];
      if (!Array.isArray(componentName)) {
        componentName = [componentName];
      }
      this.entityDefinitionMap.forEach((entityDefinition, entityName) => {
        if (componentName.every((c) => {
          var _a;
          return (_a = entityDefinition.components) == null ? void 0 : _a.some((component) => component.type === c);
        })) {
          entities.push(entityName);
        }
      });
      return entities;
    });
    __publicField(this, "getComponentFromEntity", (entityName, componentName, clone2 = false) => {
      var _a;
      const entityDefinition = this.entityDefinitionMap.get(entityName.toLowerCase());
      const component = (_a = entityDefinition == null ? void 0 : entityDefinition.components) == null ? void 0 : _a.find((c) => c.type === componentName);
      if (component && clone2) {
        return cloneDeep(component);
      }
      return component;
    });
    __publicField(this, "getEntityDefinition", (entityName, gameModel) => {
      let entityDefinition = JSON.parse(
        this.entityDefinitionStringMap.get(entityName.toLowerCase()) || "{}"
      );
      if (!entityDefinition.name) {
        entityDefinition.name = entityName;
      }
      if (gameModel) {
        entityDefinition = this.mapComplexValues(entityDefinition, gameModel);
      }
      return entityDefinition;
    });
    __publicField(this, "cache", {});
    __publicField(this, "hasEntity", (entityName) => {
      return this.entityDefinitionMap.has(entityName.toLowerCase());
    });
    __publicField(this, "generateEntity", (gameModel, entityName, componentOverrides) => {
      try {
        const entityComponents = this.mapEntityComponent(gameModel, entityName, componentOverrides);
        const createdEntity = this.createEntity(gameModel, entityComponents);
        if (entityName !== "core" && gameModel.hasComponent(gameModel.coreEntity, ListenEntityCreationSchema)) {
          gameModel.getTypedUnsafe(gameModel.coreEntity, ListenEntityCreationSchema).entity = createdEntity;
          gameModel.getSystem(ListenEntityCreationSystem).run(gameModel.coreEntity, gameModel);
        }
        return createdEntity;
      } catch (e) {
        console.error(entityName, componentOverrides);
        console.error(e);
        throw e;
      }
    });
    __publicField(this, "generateComponents", (definition) => {
      const components = definition.components ?? [];
      const type = StringToEnum(definition.type, EntityType) ?? EntityType.ENTITY;
      const mapComponent = (name, data) => {
        const component = {
          type: name,
          data
        };
        if (!components.find((c) => c.type === name)) {
          components.push(component);
        }
      };
      if (type === EntityType.PLAYER) {
        mapComponent("EntityType", { type: "EntityType", entityType: EntityType.ALLY });
      } else {
        mapComponent("EntityType", { type: "EntityType", entityType: type });
      }
      mapComponent("Description", {
        type: "Description",
        description: definition.name
      });
      switch (type) {
        case EntityType.PLAYER:
          mapComponent("PlayerType", { type: "PlayerType" });
          mapComponent("AllyType", { type: "AllyType" });
          break;
        case EntityType.ALLY:
          mapComponent("AllyType", { type: "AllyType" });
          break;
        case EntityType.ENEMY: {
          const enemyType = EnemyTypeEnum.U_DEF;
          mapComponent("EnemyType", {
            type: "EnemyType",
            enemyType
          });
          break;
        }
        case EntityType.ALTAR:
          mapComponent("AltarType", { type: "AltarType" });
          break;
        case EntityType.PICKUP:
          mapComponent("PickupType", { type: "PickupType" });
          break;
        case EntityType.PROJECTILE:
          mapComponent("ProjectileType", { type: "ProjectileType" });
          break;
        case EntityType.INTERACTABLE:
          mapComponent("InteractableType", { type: "InteractableType" });
          break;
        case EntityType.WALL:
          mapComponent("WallType", { type: "WallType" });
          break;
        case EntityType.DOOR:
          mapComponent("DoorType", { type: "DoorType" });
          break;
        case EntityType.WEAPON:
          break;
      }
      return {
        components,
        children: []
      };
    });
    console.log("entity factory constructor!");
    let list = entityDefinitions.slice();
    let inheritanceFailureCount = 0;
    let inheritanceList = [];
    while (list.length && inheritanceFailureCount++ < 100) {
      inheritanceList = [];
      list.forEach((entityDefinition) => {
        if (entityDefinition.inherits) {
          let parentLoaded = true;
          if (typeof entityDefinition.inherits === "string") {
            if (!this.entityDefinitionMap.has(entityDefinition.inherits.toLowerCase())) {
              inheritanceList.push(entityDefinition);
              parentLoaded = false;
            }
          } else {
            entityDefinition.inherits.every((x) => {
              if (!this.entityDefinitionMap.has(x.toLowerCase())) {
                inheritanceList.push(entityDefinition);
                parentLoaded = false;
                return false;
              }
              return true;
            });
          }
          if (!parentLoaded) {
            return;
          }
        }
        this.entityDefinitionMap.set(entityDefinition.name.toLowerCase(), JSON.parse(JSON.stringify(entityDefinition)));
      });
      list = inheritanceList;
    }
    if (inheritanceFailureCount >= 100) {
      console.error(inheritanceList.map((x) => x.name));
      throw new Error("Inheritance failure count exceeded 100!");
    }
    const definitions = Array.from(this.entityDefinitionMap.values());
    definitions.forEach((x) => {
      let inherits;
      x.components = (x.components || []).map((c) => {
        return typeof c === "string" ? { type: c } : c;
      });
      if (x.assets) {
        x.assets.forEach((asset) => {
          switch (asset.type) {
            case "image":
              AssetLoader.getInstance().loadImage(asset.key, asset.url);
              break;
            case "spritesheet": {
              const { key, url, type, ...spriteOptions } = asset;
              AssetLoader.getInstance().loadSprite(key, url, spriteOptions);
              break;
            }
            case "sound": {
              const { key, url, type, ...soundOptions } = asset;
              AssetLoader.getInstance().loadSound(key, url, soundOptions);
              break;
            }
            case "spine":
              AssetLoader.getInstance().loadSpine(asset.key, asset.url);
              break;
            case "map":
              AssetLoader.getInstance().loadMap(asset.key, asset.url);
              break;
            case "mapskin":
              AssetLoader.getInstance().loadMapSkin(asset.key, asset.url);
              break;
          }
        });
      }
      if (x.inherits) {
        if (typeof x.inherits === "string") {
          inherits = [x.inherits];
        } else {
          inherits = x.inherits;
        }
      }
      if (inherits) {
        inherits.forEach((inheritable) => {
          const toInherit = this.entityDefinitionMap.get(inheritable.toLowerCase());
          if (!toInherit) {
            console.error(`Could not find inheritable ${inheritable} in map!`);
            return;
          }
          const definitionCopy = JSON.parse(JSON.stringify(x));
          definitionCopy.type = definitionCopy.type ?? toInherit.type;
          definitionCopy.children = [...toInherit.children ?? [], ...definitionCopy.children ?? []];
          if (toInherit.components && toInherit.components.length > 0 && definitionCopy.components && definitionCopy.components.length > 0) {
            definitionCopy.components = Object.values(
              clone(toInherit.components).concat(definitionCopy.components).reduce((acc, x2) => {
                return { ...acc, [x2.type]: x2 };
              }, {})
            );
          } else if (toInherit.components && toInherit.components.length > 0) {
            definitionCopy.components = clone(toInherit.components);
          } else
            ;
          this.entityDefinitionMap.set(x.name.toLowerCase(), definitionCopy);
        });
      }
    });
    const finalDefinitions = Array.from(this.entityDefinitionMap.values());
    finalDefinitions.forEach((x) => {
      this.entityDefinitionStringMap.set(x.name.toLowerCase(), JSON.stringify(x));
    });
    setGlobalSingleton("EntityFactory", this);
  }
  static configureEntityFactory(entityDefinitions) {
    new EntityFactory(entityDefinitions);
  }
  static getInstance() {
    return getGlobalSingleton("EntityFactory");
  }
  mapComplexValues(data, gameModel) {
    if (Array.isArray(data)) {
      return data.map((d) => this.mapComplexValues(d, gameModel));
    } else if (typeof data === "object") {
      for (const key in data) {
        data[key] = this.mapComplexValues(data[key], gameModel);
      }
    } else if (typeof data === "string") {
      if (data === "self:") {
        return gameModel.getNextEntityId();
      }
      if (data.includes("::self::")) {
        const [prefix, suffix] = data.split("::self::");
        return prefix + gameModel.getNextEntityId() + suffix;
      }
      if (data.startsWith("enum:")) {
        const enumClassName = data.substring(5).split(".");
        return StringToEnum(enumClassName[1], getEnum(enumClassName[0]));
      }
      if (data.includes("::enum::")) {
        const enumClassName = data.substring(5).split(".");
        const [prefix, suffix] = data.split("::enum::");
        return prefix + StringToEnum(enumClassName[1], getEnum(enumClassName[0])) + suffix;
      }
      if (data.startsWith("rgb:")) {
        return hexToRgbNumber(data.substring(4));
      }
      if (data.startsWith("rand:")) {
        const randValue = gameModel.rand.number();
        const [min, max] = data.substring("rand:".length).split(":");
        if (min) {
          if (max) {
            return randValue * (parseInt(max) - parseInt(min)) + parseInt(min);
          }
          return randValue * parseInt(min);
        }
        return randValue;
      } else if (data.startsWith("randint:")) {
        const [min, max] = data.substring("randint:".length).split(":");
        const randValue = gameModel.rand.int(parseInt(min), max ? parseInt(max) : void 0);
        return randValue;
      } else if (data.startsWith("randdzint:")) {
        const [min, max] = data.substring("randdzint:".length).split(":");
        const randValue = gameModel.rand.int(parseInt(min), max ? parseInt(max) : void 0) * (gameModel.rand.number() > 0.5 ? 1 : -1);
        return randValue;
      } else if (data.startsWith("playercount:")) {
        const [multiplier] = data.substring("playercount:".length).split(":");
        return Math.max(gameModel.players.length, 0) * (multiplier ? parseInt(multiplier) : 1);
      } else {
        return data;
      }
    }
    return data;
  }
  mapEntityComponent(gameModel, entityName, componentOverrides) {
    const entityDefinition = this.getEntityDefinition(entityName, gameModel);
    const entityComponents = this.generateComponents(entityDefinition);
    if (componentOverrides) {
      entityComponents.components.forEach((c, i) => {
        if (componentOverrides[c.type]) {
          if (typeof componentOverrides[c.type] === "function") {
            entityComponents.components[i] = {
              ...c,
              ...componentOverrides[c.type](c)
            };
          } else {
            entityComponents.components[i] = {
              ...c,
              ...componentOverrides[c.type]
            };
          }
        }
      });
    }
    const dependencyOrder = [];
    const graphList = [];
    const dependencyDict = {};
    entityComponents.components.forEach((c) => {
      dependencyDict[c.type] = c;
      const dependencies = gameModel.getDependencies(c.type);
      if (!dependencies.length) {
        dependencyOrder.push(c.type);
      } else {
        for (let i = 0; i < dependencies.length; i++) {
          graphList.push([c.type, dependencies[i]]);
        }
      }
    });
    dependencyOrder.push(...toposort(graphList).reverse());
    const finalComponentList = [];
    dependencyOrder.forEach((c) => {
      if (dependencyDict[c]) {
        finalComponentList.push(dependencyDict[c]);
      }
    });
    entityComponents.components = finalComponentList;
    if (entityDefinition.children) {
      entityComponents.children = entityDefinition.children.map((childName) => {
        return this.mapEntityComponent(gameModel, childName);
      });
    }
    return entityComponents;
  }
  createEntity(gameModel, entity) {
    var _a;
    const entityId = gameModel.addEntity();
    this.addComponents(gameModel, entityId, entity.components);
    gameModel.removeComponent(entityId, "Parent");
    (_a = entity.children) == null ? void 0 : _a.forEach((child) => {
      let childComponent = child.components.find((c) => c.type === "Child");
      if (!child.components.find((c) => c.type === "Transform")) {
        child.components.push({ type: "Transform", data: { x: 0, y: 0 } });
      }
      if (!childComponent) {
        child.components.push({ type: "Child", data: { parent: entityId } });
      } else {
        if (childComponent.data) {
          childComponent.data.parent = entityId;
        } else {
          childComponent.parent = entityId;
        }
      }
      const childId = this.createEntity(gameModel, child);
      if (gameModel.hasComponent(entityId, "Parent")) {
        const parentData = gameModel.getTypedUnsafe(entityId, ParentSchema);
        parentData.children.push(childId);
      } else {
        gameModel.addComponent(entityId, "Parent", { children: [childId] });
      }
    });
    return entityId;
  }
  addComponents(gameModel, entity, components) {
    components.forEach((component) => {
      try {
        if (component.enabled === false)
          return;
        if (componentRegistered(component.type)) {
          gameModel.addComponent(entity, component.type, component.data ?? component);
          return;
        }
        console.warn("Component not registered: " + component.type);
      } catch (e) {
        console.error(component, components);
        console.error(e);
        throw e;
      }
    });
  }
}
export {
  EntityFactory
};
//# sourceMappingURL=EntityFactory.js.map
